module.exports = __webpack_public_path__ + "img/chart-line-icon-light.1da25a46.svg";